import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ImmediateOfferSection } from '../components/ImmediateOfferSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { ClassesSection } from '../components/ClassesSection';
import { FAQSection } from '../components/FAQSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GallerySection } from '../components/GallerySection';
import { CommunitySection } from '../components/CommunitySection';
import { OffersSection } from '../components/OffersSection';
import { LocationSection } from '../components/LocationSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { MobileCtaBar } from '../components/MobileCtaBar';
export function HomePage() {
  return <div className="min-h-screen flex flex-col font-body bg-bg text-text" data-id="element-514">
      <Navbar data-id="element-515" />

      {/* pb-16 on mobile to clear the sticky bottom CTA bar */}
      <main className="flex-grow pb-16 lg:pb-0" data-id="element-516">
        <HeroSection data-id="element-517" />
        <ImmediateOfferSection data-id="element-518" />
        <WelcomeSection data-id="element-519" />
        <ClassesSection data-id="element-520" />
        <FAQSection data-id="element-521" />
        <TestimonialsSection data-id="element-522" />
        <GallerySection data-id="element-523" />
        <CommunitySection data-id="element-524" />
        <OffersSection data-id="element-525" />
        <LocationSection data-id="element-526" />
        <FinalCTASection data-id="element-527" />
      </main>

      <Footer data-id="element-528" />

      {/* Mobile sticky bottom CTA bar */}
      <MobileCtaBar data-id="element-529" />
    </div>;
}